module.exports = __webpack_public_path__ + "img/google-play-badge.d15a53ad.png";